import { ref, computed } from 'vue';

/**
 * Portal 类型判断 hook
 * 通过 URL hash 中的模型名或路由路径判断当前所处 portal
 * - 经销工作台 (distributor): 模型包含 'distributor' 或 'DistMall'
 * - 品牌分销工作台 (seller): 模型包含 'seller' 或 'Seller'
 * - 分销运营中心 (platform): 模型包含 'platform' 或 'Platform'
 * - 默认 (settlement): 基础模型或运营中心
 */
export type PortalType = 'settlement' | 'platform' | 'seller' | 'distributor';

export function usePortalType() {
  const portalType = ref<PortalType>(detectPortalType());

  function detectPortalType(): PortalType {
    const hash = window.location.hash || '';
    const href = window.location.href || '';
    const combined = hash + href;

    // 经销工作台：URL 包含 merchant / distributor / DistMall / dist-mall
    if (combined.includes('merchant') || combined.includes('Merchant') || combined.includes('distributor') || combined.includes('DistMall') || combined.includes('dist-mall')) {
      return 'distributor';
    }
    if (combined.includes('seller') || combined.includes('Seller')) {
      return 'seller';
    }
    if (combined.includes('platform') || combined.includes('Platform')) {
      return 'platform';
    }
    return 'settlement';
  }

  /** 是否经销工作台（仅查看，不开放财务操作） */
  const isDistributor = computed(() => portalType.value === 'distributor');

  /** 是否品牌分销工作台（省区财务，可提交审批） */
  const isSeller = computed(() => portalType.value === 'seller');

  /** 是否分销运营中心或总部（拥有完整财务操作权限） */
  const isOperationCenter = computed(() => portalType.value === 'platform' || portalType.value === 'settlement');

  return {
    portalType,
    isDistributor,
    isSeller,
    isOperationCenter
  };
}
